import * as axios from '../axios-extended'
import * as t from 'io-ts'
import { CancelToken } from 'axios'

export const Profile = t.intersection(
  [
    t.type({
      nym: t.string,
      createdAt: t.string,
    }),
    t.partial({
      androidVersion: t.string,
      appCategory: t.string,
      birthDate: t.string,
      cinRecto: t.string,
      cinVerso: t.string,
      deviceID: t.string,
      firstName: t.string,
      gender: t.string,
      governorate: t.string,
      imei: t.string,
      lastName: t.string,
      operatorName: t.string,
      phoneNumber: t.string,
      scannedCin: t.string,
      status: t.string,
      userFace: t.string,
    }),
  ],
  'Profile'
)
export type Profile = t.TypeOf<typeof Profile>

const Response = t.type({
  count: t.number,
  profiles: t.array(Profile),
})

export const getProfiles = (
  page = 0,
  size = 20,
  term = '',
  sortColumn = 'createdAt' as keyof Profile,
  sortOrder = 'desc' as 'asc' | 'desc',
  cancelToken?: CancelToken
) =>
  axios.get('/dis/dis/1.0/profile', {
    decoder: Response,
    params: {
      search: term,
      page,
      itemsPerPage: size,
      orderby: sortColumn[0].toUpperCase() + sortColumn.slice(1),
      order: sortOrder,
    },
    cancelToken,
  })
